export const AETHER_TIDE = [
  100,82,105,115,104,116,73
];
